import moment from 'moment';

export {}; // this file needs to be a module
Date.prototype.toOkDateString = function (this: Date): string {
  return moment(this).format('YYYY-MM-DD');
};
